export const GOOGLE_MAPS_API_KEY = 'AIzaSyD1VmydeASm4dawh3VO8b-lYlvM5exe4NY';
